class ArrayHelper {
    constructor(array) {
        this.array = array
    }

    first() {
        return this.array[0]
    }

    last() {
        return this.array[this.array.length - 1]
    }

    lastIndex() {
        return this.array.length - 1
    }

    count(element) {
        return this.array.reduce((accumulator, current) => {
            return (current === element) ? accumulator + 1 : accumulator
        }, 0)
    }

    isEmpty() {
        return !!(this.array && !this.array.length)
    }

    isNotEmpty() {
        return !!(this.array && this.array.length)
    }

    allSatisfy(condition) {
        this.array.reduce((accumulator, element) => {
            accumulator = accumulator && condition(element)
        }, false)
    }

    isLastIndex(index) {
        return this.array && (index === this.array.length - 1)
    }

    isNotLastIndex(index) {
        return this.array && (index < this.array.length)
    }

    mergeMax(otherArray) {
        const isABigger = this.array.length > otherArray.length
        const biggest = isABigger ? this.array : otherArray
        const smallest = isABigger ? otherArray : this.array

        return biggest.map((value, index) => {
            const otherValue = smallest[index]
            return (otherValue && otherValue > value) ? otherValue : value
        })
    }

    contains(value) {
        return this.array.indexOf(value) >= 0
    }

    isValidIndex(index) {
        const { array } = this
        return !isNaN(index) && array && 0 <= index < array.length
    }
}

export default function(array) {
    return new ArrayHelper(array)
}
